import { __awaiter, __generator } from "tslib";
import { createDeprecatedInputDriver } from '../../primitives/drivers';
export var createFormInputDriver = function (wrapper) {
    var baseDriver = wrapper.$('.form-input');
    var inputDriver = createDeprecatedInputDriver(wrapper);
    return {
        value: function () { return inputDriver.value(); },
        set: function (value) { return inputDriver.enterValue(value); },
        pressEnter: function () { return inputDriver.pressEnter(); },
        isDisabled: function () { return inputDriver.disabled(); },
        isReadOnly: function () { return inputDriver.readOnly(); },
        valid: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, baseDriver.hasClass('invalid')];
                case 1: return [2 /*return*/, !(_a.sent())];
            }
        }); }); },
        placeholder: function () { return inputDriver.placeholder(); },
        getValidationMessage: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, baseDriver.$('.validation-msg').exists()];
                    case 1: return [2 /*return*/, (_a.sent()) ?
                            baseDriver.$('.validation-msg').text() : ''];
                }
            });
        }); },
        getLabel: function () { return baseDriver.$('.label-text').text(); }
    };
};
//# sourceMappingURL=driver.js.map